export const createTimestampedName = (name: string) =>
  `${name} ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
